import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import { getCourseById } from "../../service/service";
import { ViewOnlyPages } from "../../theme";
import { Visibility } from "@mui/icons-material";

const CourseDetailView = () => {
  const { id } = useParams();
  const [course, setCourse] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchCourse = async () => {
    try {
      const fetchedCourse = await getCourseById(id);
      setCourse(fetchedCourse.data);
      setLoading(false);
    } catch (error) {
      console.log("Failed to fetch course:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourse();
  }, [id]);

  if (loading)
    return (
      <Backdrop open={loading} sx={{ zIndex: 1 }}>
        <CircularProgress />
      </Backdrop>
    ); // Loading state

  return (
    <ThemeProvider theme={ViewOnlyPages}>
      <Layout>
        <Box sx={{ padding: 2 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h4" gutterBottom>
              Course Details
            </Typography>
            <div className="image-container">
              <img src={course.image} width="100" height="100" alt="Course" />
            </div>
          </div>

          <TextField
            label="Course Name"
            variant="outlined"
            fullWidth
            disabled
            value={course.name}
            margin="normal"
          />
          <TextField
            label="Description"
            variant="outlined"
            fullWidth
            disabled
            multiline
            rows={4}
            value={course.description}
            margin="normal"
          />

          <Typography variant="h6" gutterBottom>
            Units
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Order</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Is Bonus</TableCell>
                  <TableCell>Edit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {course.units.map((unit) => (
                  <TableRow key={unit._id}>
                    <TableCell>{unit.order}</TableCell>
                    <TableCell sx={{ width: "20%" }}>
                      <TextField
                        variant="outlined"
                        multiline
                        disabled
                        maxRows={4}
                        value={unit.name}
                        sx={{ width: "100%" }}
                      />
                    </TableCell>
                    <TableCell sx={{ width: "40%" }}>
                      <TextField
                        variant="outlined"
                        multiline
                        disabled
                        maxRows={4}
                        value={unit.description}
                        sx={{ width: "100%" }}
                      />
                    </TableCell>
                    <TableCell>
                      <FormControlLabel
                        control={<Checkbox disabled checked={unit.isBonus} />}
                        label="Is Bonus"
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        component={Link}
                        to={`/course/${id}/units/${unit._id}/view`}
                        variant="contained"
                        color="primary"
                        endIcon={<Visibility />}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Layout>
    </ThemeProvider>
  );
};

export default CourseDetailView;
